// src/utils/Constants.js

const REDIR_BASE = "https://mydata.tablemate.net/redir.php?url=";

/**
 * Constants helper.
 *
 * Pass in the tenant server URL you got from login (user.server_url),
 * e.g. "https://wazzzasroom.tablemate.net"
 *
 * NOTE: menuApi will append "/tablemate/endpoints/..." itself,
 * so this should usually be just the host, not including "/tablemate".
 */
export default class Constants {
  constructor(serverUrl) {
    let tenant = serverUrl;

    // Fallbacks if nothing was passed in
    if (!tenant && typeof window !== "undefined") {
      try {
        tenant =
          window.TM_TENANT_SERVER_URL ||
          localStorage.getItem("tm.tenantServerUrl") ||
          localStorage.getItem("tm.server_url") ||
          localStorage.getItem("server_url") ||
          null;
      } catch {
        // ignore storage errors
      }
    }

    // Normalize: drop trailing slashes
    const root = (tenant || "").replace(/\/+$/, "");

    // 👇 this is what menuApi wants as its first param
    this.tenantServerUrl = root;

    // These are for your older "endpoints via redir" style calls.
    // If your PHP endpoints live under /tablemate, adjust here.
    const endpointsRoot = root ? `${root}/tablemate/endpoints` : "";
    const imageRoot = root ? `${root}/tablemate/` : "";

    // Final proxied URLs via redir.php (for legacy consumers)
    this.baseURL = endpointsRoot
      ? `${REDIR_BASE}${encodeURIComponent(endpointsRoot)}`
      : "";

      
    this.baseImageURL = imageRoot
      ? `${REDIR_BASE}${encodeURIComponent(imageRoot)}`
      : "";

    this.rolesList = {
      "1": "Waiter",
      "2": "Kitchen Staff",
      "3": "Manager",
      "4": "Administrator",
    };

    this.experienceList = ["Rookie", "Proficient", "Expert", "Veteran"];
  }

  /* ----- lookups ----- */

  getRolesList() {
    return this.rolesList;
  }

  getExperienceList() {
    return this.experienceList;
  }

  getBaseURL() {
    return this.baseURL;
  }

  getBaseImageURL() {
    return this.baseImageURL;
  }

  /** 👇 used by menuApi consumers */
  getTenantServerUrl() {
    return this.tenantServerUrl;
  }

  /**
   * Helper to build Constants from the logged-in user object.
   * Adjust the field name (server_url) to whatever your login returns.
   */
  static fromAuthUser(user) {
    return new Constants(
      user?.server_url ||
        user?.tenantServerUrl ||
        user?.serverUrl ||
        null
    );
  }
}
